// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"7150a1d8","545":"a6fece4b"}[chunkId] + ".chunk.js";
};